import { createElementBlock as a, openBlock as o, normalizeClass as d, createElementVNode as e, createBlock as n, toDisplayString as i, createTextVNode as c, createCommentVNode as l } from "vue";
import g from "../../atoms/image-element/image-element.vue.js";
import { screenProp as m } from "../../utils/utilsScreen.js";
/* empty css                   */
const u = { class: "ds-container" }, h = { class: "ds-grid ds-justify-content-center" }, y = ["src", "alt"], f = {
  class: "ds-color-green ds-text ds-font-weight-bold",
  "data-j-authorname": ""
}, w = { "data-j-authorrole": "" }, j = { key: 0 }, _ = /* @__PURE__ */ Object.assign({
  name: "DsSectionQuote"
}, {
  __name: "section-quote",
  props: {
    ...m,
    withLogo: {
      type: Boolean,
      default: !0
    },
    image: {
      type: Object,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    authorName: {
      type: String,
      required: !0
    },
    authorRole: {
      type: String,
      required: !0
    },
    authorCity: {
      type: String,
      default: null
    }
  },
  setup(t) {
    return (r, s) => (o(), a("section", {
      class: d(["ds-quote", { "ds-quote--gradient": t.withLogo }])
    }, [
      e("div", u, [
        e("div", {
          class: d(["ds-width-full", { "ds-background-color-white": t.withLogo }]),
          "data-j-container": ""
        }, [
          e("div", h, [
            e("div", {
              class: d(["ds-grid__col ds-grid__col--12", { "ds-md-grid__col--10": t.withLogo }])
            }, [
              e("div", {
                class: d({
                  "ds-padding-y-24 ds-md-padding-y-48 ds-lg-padding-y-96 ds-padding-x-24 ds-md-padding-x-0": t.withLogo
                })
              }, [
                e("div", {
                  class: d(["ds-margin-bottom-24", { "ds-md-margin-bottom-48": !t.withLogo }])
                }, [
                  t.withLogo ? (o(), a("img", {
                    key: 0,
                    class: "ds-quote__logo",
                    src: t.image.src,
                    alt: t.image.alt,
                    "data-j-image": ""
                  }, null, 8, y)) : (o(), n(g, {
                    key: 1,
                    image: t.image,
                    screen: r.screen,
                    "border-radius": "",
                    "data-j-image": ""
                  }, null, 8, ["image", "screen"]))
                ], 2),
                e("p", {
                  class: d(["ds-text-medium ds-margin-bottom-24", {
                    "ds-grid__col ds-grid__col--no-gutter ds-grid__col--12 ds-md-grid__col--10 ds-lg-grid__col--7": !t.withLogo
                  }]),
                  "data-j-desc": ""
                }, " “" + i(t.description) + "” ", 3),
                e("p", null, [
                  e("span", f, i(t.authorName), 1),
                  s[0] || (s[0] = c(" — ")),
                  e("span", w, i(t.authorRole), 1),
                  t.authorCity ? (o(), a("span", j, ", " + i(t.authorCity), 1)) : l("", !0)
                ])
              ], 2)
            ], 2)
          ])
        ], 2)
      ])
    ], 2));
  }
});
export {
  _ as default
};
